// extracted by mini-css-extract-plugin
export default {"customLinksMenu":"CustomLinksMenu_customLinksMenu__3IuWL"};